import React from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { Divider } from '@vio/atlas/Divider';
import { Flex } from '@vio/atlas/helpers/Flex';
import { Text } from '@vio/atlas/Text';
const Wrapper = /*#__PURE__*/styled('section')({
  name: "Wrapper",
  class: "wmwiyhz",
  propsAsIs: false
});
const itemHeading = "ikhpc3";
const HeadingWrapper = /*#__PURE__*/styled('div')({
  name: "HeadingWrapper",
  class: "hexnx52",
  propsAsIs: false
});
const _exp6 = /*#__PURE__*/() => Text;
const Subtitle = /*#__PURE__*/styled(_exp6())({
  name: "Subtitle",
  class: "spz0vy7",
  propsAsIs: true
});
interface FilterOverlayItemProps {
  /** The title to display above the children */
  title?: React.ReactNode;
  /** The title to display below the title */
  subtitle?: React.ReactNode;
  /** The icon to display next to the title */
  icon?: React.ReactNode;
  /** The children of the wrapper - the filter component */
  children: React.ReactNode;
  /** The data-id applied to the wrqpper */
  dataId?: string;
  withDivider?: boolean;
  hasShowMore?: boolean;
}

/**
 * Wrapper used to display each filter within the all filters overlay
 */
export const FilterOverlayItem = ({
  children,
  title,
  subtitle,
  icon,
  dataId,
  withDivider = true,
  hasShowMore = false
}: FilterOverlayItemProps) => {
  return <>
      <Wrapper data-id={dataId} className={cx(hasShowMore && '__hasShowMore')}>
        {title && <HeadingWrapper>
            <Flex.Row alignItems="center" gap="s250">
              {icon}
              <Text as="h3" variant="titleL" className={itemHeading}>
                {title}
              </Text>
            </Flex.Row>
            {subtitle && <Subtitle variant="bodyS" colorPath="content.neutral.c600">
                {subtitle}
              </Subtitle>}
          </HeadingWrapper>}
        {children}
      </Wrapper>
      {withDivider && <Divider />}
    </>;
};

require("./FilterOverlayItem.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./FilterOverlayItem.tsx");